import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logOutToken } from '../actions/app_token'
import { updatePlan, getPlans, deletePlan, deletePlanFailure, getPlansFailure, updatePlanFailure, getPlanTags  } from '../actions/plan'
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import '../App.css';
import 'semantic-ui-css/semantic.min.css';
import history from '../history'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import * as paths from '../constants'
import ConfirmToastr from '../components/confirm_toastr';
import SystemHeader from '../components/system_header'
import { getTranslations } from '../actions/language'
import Feedback from '../components/feedback'
import moment from 'moment'
import TagsDropdown from '../components/tags_dropdown'
import UserPlanPermissionTable from '../components/user_plan_permission_table'
import ObjectITButton from '../components/developed_by_objectit';

class AdminDashBoard extends Component {
  constructor(props){
    super(props);

    this.state = {
      plans: [],
      templates: [],
      sidebarShown: false,
      pendingMessage: "",
      activeItem: 'risk_templates',
      notifications: "",
      messageShown: false,
      messageTimer: null,
      rowId: null,
      planName: null,
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      userPlanPermissionTableModalOpen: false,
      tagOptions: [
        "NBT-Allison",
        "RDO-WDM",
        "RDO-MLE",
        "HVC-2040",
        "QB3",
        "EVO-Harmer",
        "EVO-SRF 2",
        "FRO-Eagle 4 SRF",
        "FRO-AWTF S",
        "FRO-AWTF N",
        "FRO-Diversion"
      ],
      templateRowEvents: {
        onDoubleClick: this.editTemplate
      },
      searchTerm: '',
      tagFilters: [],
    }

    const { name, last_modified, date_created, tags } = this.props.language.translations

    this.plansColumns = [
      {
        dataField: 'name',
        text: name,
        formatter: (cell, row) => this.nameFormatter(cell, row),
        headerTitle: true,
        title: true,
        headerStyle: {
          width: '33%'
        },
      },
      {
        dataField: 'tags',
        text: tags,
        formatter: (cell, row) => this.tagsFormatter(cell, row),
        headerTitle: true,
        title: false,
        editable: false,
        headerStyle: {
          width: '30%'
        },
      },
      {
        dataField: 'updated_at',
        text: last_modified,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '12%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'created_at',
        text: date_created,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '12%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.plansButtonsFormatter(cell, row),
        headerStyle: {
          width: '13%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ]

    this.templatesColumns = [
      {
        dataField: 'name',
        text: name,
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true,
        headerStyle: {
          width: '66%'
        },
      },
      {
        dataField: 'updated_at',
        text: last_modified,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '12%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'created_at',
        text: date_created,
        formatter: this.cellFormatter,
        headerStyle: {
          width: '12%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.templatesButtonsFormatter(cell, row),
        headerStyle: {
          width: '10%'
        },
        headerTitle: true,
        title: true,
        editable: false
      },
    ]

  }

  componentWillMount = () => {
    if (!this.props.signedIn) {
      return history.push(paths.LOGIN_PATH)
    }
    else if (!this.props.isAdmin) {
      return history.push(paths.DASHBOARD_PATH)
    }
  }

  componentDidMount = () => {
    this.props.getTranslations('English');
    var options = {
      search_term: this.state.searchTerm,
      is_template: true,
      tag_filters: this.state.tagFilters,
      plan_ids: this.props.user.plan_ids
    }
    this.props.getPlans(options).then(()=>{
      this.getTagOptions();
    });
  }

  componentWillReceiveProps = (nextProps) => {
    var translations = nextProps.language.translations
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
      }, ()=>{
        this.plansColumns[0].text = translations.name
        this.plansColumns[1].text = translations.tags
        this.plansColumns[2].text = translations.last_modified
        this.plansColumns[3].text = translations.date_created
        this.templatesColumns[0].text = translations.name
        this.templatesColumns[1].text = translations.last_modified
        this.templatesColumns[2].text = translations.date_created
        this.forceUpdate();
      })
    }

    if (nextProps.getPlansPending){
      this.setState({
        notifications: "  (" + translations.fetching + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.getPlansSuccess){
      if (nextProps.isTemplate){
        this.setState({
          templates: this.formatPlans(nextProps.plans),
          notifications: ""
        })
      }
      else {
        this.setState({
          plans: this.formatPlans(nextProps.plans),
          notifications: ""
        })
      }
      this.showNotifications(true);
      this.props.resetGetPlans();
    }

    if (nextProps.updatePending){
      this.setState({
        notifications: "  (" + translations.updating + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.updateSuccess){
      this.setState({
        notifications: "  (" + translations.changes_to + " '"+ nextProps.plan.name +"' " + translations.has_been_saved + ".)"
      });
      this.showNotifications(true);
      this.props.resetUpdate();
    }

    if (nextProps.deletePending){
      this.setState({
        notifications: "  (" + translations.deleting + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.deleteSuccess){
      this.setState({
        notifications: nextProps.plan.name + " " + translations.has_been_deleted + "."
      })
      this.showNotifications(true);
      this.props.resetDelete();
      var options = {
        search_term: this.state.searchTerm,
        tag_filters: this.state.tagFilters,
        plan_ids: this.props.user.plan_ids
      }
      if (nextProps.isTemplate){
        options.is_template = true
        this.props.getPlans(options);
      }
      else{
        options.is_template = false
        this.props.getPlans(options);
      }
    }

  };

  formatPlans = (plans) => {
    for(var i = 0; i < plans.length; i++) {
      var updated_at = new Date(plans[i].updated_at)
      plans[i].updated_at = moment(updated_at).format("DD MMM YYYY HH:mm A")
      var created_at = new Date(plans[i].created_at)
      plans[i].created_at = moment(created_at).format("DD MMM YYYY HH:mm A")
    }
    return plans
  }

  showNotifications = (timed) => {
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, 3000);
    }
  }

  loadingMessage = (pending) => {
    var messageblock = document.getElementById("create-notification");
    if (pending){
      this.setState({
        pendingMessage: this.state.translations.fetching_plan
      })
      messageblock.style.display = "inline";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  cellFormatter = (cell, row) => {
    return (
     <div className='cell-style'>
      { cell }
     </div>
    );
  }

  nameFormatter = (cell, row) => {
    return (
     <div className='cell-style'>
      <span title={cell}>{ cell }</span>
     </div>
    );
  }

  tagsFormatter = (cell, row) => {
    return (
     <div className='cell-style' onClick={(evt)=>evt.stopPropagation()}>
      {
        row.tag_list.length > 0 &&
        <span className='tags-container'>
          {
            row.tag_list.map((tag, index)=>{
              return(
                <span key={index} className='tag'>{tag} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.onRemoveTag(tag, row)}></i></span>
              )
            })
          }
        </span>
      }
     </div>
    );
  }

  onRemoveTag = (tag, row) => {
    var tagList = row.tag_list
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onApplyTags(tagList, row)
  }

  onApplyTags = (tagList, row) => {
    row.tag_list = tagList
    this.props.updatePlan(row)
  }

  onNewTag = (tag) => {
    var tagOptions = this.state.tagOptions
    if (!tagOptions.includes(tag)){
      tagOptions.splice(0,0,tag)
      this.setState({
        tagOptions: tagOptions
      })
    }
  }

  getTagOptions = () => {
    this.props.getPlanTags().then(()=>{
      var tagOptions = this.state.tagOptions
      tagOptions = tagOptions.concat(this.props.planTags)
      tagOptions = [...new Set(tagOptions)]
      this.setState({
        tagOptions: tagOptions
      })
    })
  }

  plansButtonsFormatter = (cell, row) => {
    const { tags, tag_as } = this.state.translations
    const delete_label = this.state.translations.delete
    const trigger = (<a className='plan-action'>{tags}</a>)
    return (
     <div className='cell-style'>
      <a className='plan-action red' onClick={() => this.showMessage(row)}>{delete_label}</a>
      {
        <TagsDropdown
         className='tags-dropdown'
         trigger={trigger}
         header={`${tag_as}:`}
         translations={this.state.translations}
         tagList={row.tag_list}
         onApply={(tagList)=>this.onApplyTags(tagList, row)}
         tagOptions={this.state.tagOptions}
         onNewTag={this.onNewTag}
         addable={true}
         searchable={true}
        />
      }
      <a className='plan-action' onClick={this.toggleUserPlanPermissions}>{"Permissions"}</a>
     </div>
    );
  }

  templatesButtonsFormatter = (cell, row) => {
    const edit_template = this.state.translations.edit_template
    return (
     <div className='cell-style'>
      <a className='plan-action' onClick={() => history.push("/admin/" + row.id)}>{edit_template}</a>
     </div>
    );
  }

  confirmDelete = () => {
    const { yes, no } = this.state.translations
    var message = this.state.translations.sure_to_delete + " '"+ this.state.planName +"'?"
    if (this.state.messageShown ) {
      return (
        <ConfirmToastr
          messageBody={message}
          messageType="info"
          messageYes={()=>this.props.deletePlan(this.state.rowId)}
          dismiss={ this.dismissMessage.bind(this) }
          options={{ yes: yes, no: no }}
          />
        )
    }
    return null;
  }

  showMessage = (row) => {
    this.setState({
      messageShown: true,
      rowId: row.id,
      planName: row.name
    })
  }

  dismissMessage = () => {
    this.setState({
      messageShown: false
    })
  }

  handleItemClick = (e, name ) => {
    this.setState({
      activeItem: name
    });
    var risk_plans_el = document.getElementById('risk-plans');
    var risk_templates_el = document.getElementById('risk-templates');
    var options = {
      search_term: this.state.searchTerm,
      tag_filters: this.state.tagFilters,
      plan_ids: this.props.user.plan_ids
    }
    if (name === 'risk_plans'){
      options.is_template = false
      this.props.getPlans(options);
      risk_plans_el.style.display = "block";
      risk_templates_el.style.display = "none";
    }
    else {
      options.is_template = true
      this.props.getPlans(options);
      risk_plans_el.style.display = "none";
      risk_templates_el.style.display = "block";
    }
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  updatePlan = (oldValue, newValue, row, column) => {
    if (oldValue !== newValue){
      this.props.updatePlan(row)
    }
  }

  editTemplate = (e, row, rowIndex) => {
    history.push("/admin/" + row.id)
  }

  onSearch = (evt) => {
    this.setState({
      searchTerm: evt.target.value
    })
    var options = {
      search_term: evt.target.value,
      is_template: false,
      tag_filters: this.state.tagFilters,
      plan_ids: this.props.user.plan_ids
    }
    this.props.getPlans(options)
  }

  onFilterByTags = (tags) => {
    this.setState({
      tagFilters: tags
    })
    var options = {
      search_term: this.state.searchTerm,
      is_template: false,
      tag_filters: tags,
      plan_ids: this.props.user.plan_ids
    }
    this.props.getPlans(options)
  }

  removeFromTagFilters = (tag) => {
    var tagList = this.state.tagFilters
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onFilterByTags(tagList)
  }

  clearFilters = (evt) => {
    this.setState({
      tagFilters: [],
      searchTerm: ''
    })
    var options = {
      search_term: '',
      is_template: false,
      tag_filters: [],
      plan_ids: this.props.user.plan_ids
    }
    this.props.getPlans(options)
  }

  toggleUserPlanPermissions = () => {
    const willOpen = !this.state.userPlanPermissionTableModalOpen
    const userPlanPermissionFilters = {}

    if( willOpen && this.state.searchTerm !== "" ||  this.state.tagFilters.length > 0 ){
      userPlanPermissionFilters.planIds = this.props.plans.map( plan => plan.id )
      userPlanPermissionFilters.searchTerm = this.state.searchTerm
      userPlanPermissionFilters.tagFilters = this.state.tagFilters
      return this.setState({ userPlanPermissionTableModalOpen: willOpen,
                             userPlanPermissionFilters: userPlanPermissionFilters })
    }

    this.setState({ userPlanPermissionTableModalOpen: willOpen, userPlanPermissionFilters: userPlanPermissionFilters })
  }

  render(props) {
    const { sidebarShown, activeItem, plans, templates, templateRowEvents } = this.state
    const { edit_files, risk_plans, risk_templates, create_instruction, exit_admin_view, manage_users,
            filter_by_tags, clear_filters, search_plans, filter_as } = this.state.translations
    return (
      <div className="App">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item className='admin' name='home' as={Link} to={paths.DASHBOARD_PATH}>
              <span className="sidebar-button-wrap"><Icon name='arrow left'></Icon><div>{exit_admin_view}</div></span>
            </Menu.Item>
            <Menu.Item className='selected' name='home' as={Link} to={paths.ADMIN_DASHBOARD_PATH}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div>{edit_files}</div></span>
            </Menu.Item>
            <Menu.Item name='control-inventory' as={Link} to={paths.LIBRARY_CONTROLS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='file'></Icon><div>{"Control Library"}</div></span>
            </Menu.Item>
            <Menu.Item name='users' as={Link} to={paths.USERS_PATH}>
              <span className="sidebar-button-wrap"><Icon name='users'></Icon><div>{manage_users}</div></span>
            </Menu.Item>
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                notifications={this.state.notifications}
                pendingMessage={this.state.pendingMessage}
                showLogout={true}
                view='admin-dashboard'
                showMenuButton={true}
                showLanguage={false}
              />
              <Menu>
                <Menu.Item
                  name='risk_plans'
                  active={activeItem === 'risk_plans'}
                  onClick={(evt)=>this.handleItemClick(evt, 'risk_plans')}
                >
                  {risk_plans}
                </Menu.Item>

                <Menu.Item
                  name='risk_templates'
                  active={activeItem === 'risk_templates'}
                  onClick={(evt)=>this.handleItemClick(evt, 'risk_templates')}
                >
                  {risk_templates}
                </Menu.Item>
                {
                  activeItem === 'risk_plans' &&
                  <Menu.Item
                    name='toolbar-item'
                    className='toolbar-item'
                  >
                    <form autoComplete="off">
                      <div className="ui input"><input type="text" placeholder={search_plans} value={this.state.searchTerm} onChange={this.onSearch} /></div>
                    </form>
                    {
                      <TagsDropdown
                       className='tags-dropdown'
                       trigger={(<a className='plan-action'>{filter_by_tags}</a>)}
                       header={`${filter_as}:`}
                       translations={this.state.translations}
                       tagList={this.state.tagFilters}
                       onApply={this.onFilterByTags}
                       tagOptions={this.state.tagOptions}
                       addable={false}
                       searchable={true}
                      />
                    }
                    {
                      this.state.tagFilters.length > 0 &&
                      <span className='tags-container'>
                        {
                          this.state.tagFilters.map((tag, index)=>{
                            return(
                              <span key={index} className='tag'>{tag} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.removeFromTagFilters(tag)}></i></span>
                            )
                          })
                        }
                      </span>
                    }
                    <a className='plan-action' onClick={this.clearFilters}>{clear_filters}</a>
                  </Menu.Item>
                }
              </Menu>
              { this.confirmDelete() }
              <div className="risks-table" id="risk-plans" style={{ display: 'none' }}>
                <BootstrapTable
                  tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                  keyField="id"
                  data={ plans }
                  columns={ this.plansColumns }
                  cellEdit={ cellEditFactory({
                      mode: 'click',
                      blurToSave: true,
                      afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) }
                    })
                  }
                  striped
                  hover
                  condensed
                  noDataIndication={() => <span className="no-data-indication"><i className="file alternate icon"></i>{create_instruction}</span>}
                />
              </div>

              <div className="risks-table" id="risk-templates" style={{ display: 'block' }}>
                <BootstrapTable
                  tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                  keyField="id"
                  data={ templates }
                  columns={ this.templatesColumns }
                  cellEdit={ cellEditFactory({ mode: 'click',blurToSave: true, afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) } }) }
                  striped
                  hover
                  condensed
                  noDataIndication={() => <span className="no-data-indication"><i className="file alternate icon"></i>{create_instruction}</span>}
                  rowEvents={templateRowEvents}
                />
              </div>

              { this.state.userPlanPermissionTableModalOpen &&
                <UserPlanPermissionTable
                  translations={this.state.translations}
                  plans={this.state.plans}
                  open={this.state.userPlanPermissionTableModalOpen}
                  close={this.toggleUserPlanPermissions}
                  filter={this.state.userPlanPermissionFilters}
                />
              }
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    isAdmin: state.app_token.isAdmin,
    user: state.app_token.user,
    plan: state.plan.plan,
    plans: state.plan.plans,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    deleteSuccess: state.plan.deleteSuccess,
    deletePending: state.plan.deletePending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    language: state.language.language,
    languages: state.language.languages,
    planTags: state.plan.planTags,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    getPlans: (options) => dispatch(getPlans(options)),
    deletePlan: (plan_id) => {
      dispatch(deletePlan(plan_id));
    },
    resetDelete: () => {
      dispatch(deletePlanFailure());
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    getTranslations: (name) => {
      dispatch(getTranslations(name))
    },
    getPlanTags: () => dispatch(getPlanTags()),
  }
}

let DashboardPage = connect(mapStateToProps, mapDispatchToProps)(AdminDashBoard)
export default DashboardPage;



// WEBPACK FOOTER //
// ./src/views/admin_dashboard.js